import { render, staticRenderFns } from "./OfferCtaWithDevicePopin.vue?vue&type=template&id=740c206d"
import script from "./OfferCtaWithDevicePopin.vue?vue&type=script&lang=js"
export * from "./OfferCtaWithDevicePopin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports